import {sha256} from '../../../global-utils/helper-implementations/sha256';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {DataLayerEvent} from '../helpers/datalayer';

export type NewsLetterEvent = {
  GA4: DataLayerEvent;
};
export const trackNewsletter =
  ({
    action,
    email,
  }: {
    action: 'subscribed' | 'unsubscribed' | 'email_verified';
    email: string;
  }) =>
  (clientState: TrackingClientStateHolder): NewsLetterEvent => {
    const emailHash = sha256(email);
    const {currentPage} = clientState.getCurrent();

    const eventGA4 = {
      event: 'newsletter',
      action,
      eh: emailHash,
      value: null,
      content_name: currentPage?.page?.path || '',
      page_type: currentPage?.page?.type || '',
      page_type_id:
        currentPage?.type === 'detailed' ? `${currentPage.page?.id || ''}` : '',
    };

    const event = {
      GA4: eventGA4,
    };

    return event;
  };
